import React, { useState } from 'react';
import { Archive, ArchiveRestore } from 'lucide-react';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { archiveRec } from './mbApi';

const KEEP = {
  workflows: 'Versi, ujian, URL/invite link, metric, join dan pembelajaran task ni KEKAL — link iklan tak dibatalkan.',
  creatives: 'Ujian, link iklan, metric, join, review dan pembelajaran versi ni KEKAL. Link iklan tak dibatalkan.',
  tests: 'URL/invite link, Ad ID, metric dan join ujian ni KEKAL — link iklan masih berfungsi.',
};

export const ArchiveToggle = ({ ibId, kind, rec, label, reload, testid, className = '', withText = false }) => {
  const [open, setOpen] = useState(false);
  const restore = !!rec.archived;
  const go = async () => { setOpen(false); if (await archiveRec(ibId, kind, rec.id, restore)) reload(); };
  return (
    <>
      <button onClick={() => setOpen(true)} className={`min-w-10 min-h-10 inline-flex items-center justify-center gap-1.5 rounded hover:text-amber-400 hover:bg-white/5 ${className}`}
        aria-label={restore ? `Pulihkan ${label}` : `Arkib ${label}`} title={restore ? 'Pulihkan' : 'Arkib (sejarah kekal)'} data-testid={testid}>
        {restore ? <ArchiveRestore size={16} /> : <Archive size={16} />}
        {withText && <span className="text-sm">{restore ? 'Pulihkan dari arkib' : 'Arkib task'}</span>}
      </button>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent className="mb-scope" data-testid={`${testid}-dialog`}>
          <AlertDialogHeader>
            <AlertDialogTitle>{restore ? `Pulihkan ${label}?` : `Arkib ${label}?`}</AlertDialogTitle>
            <AlertDialogDescription>
              {restore ? 'Rekod ni akan kembali ke papan kerja dengan semua sejarahnya.' : `Rekod ni disembunyikan dari papan kerja. ${KEEP[kind]} Manager boleh pulihkan bila-bila.`}
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid={`${testid}-cancel`}>Batal</AlertDialogCancel>
            <AlertDialogAction onClick={go} data-testid={`${testid}-confirm`}>{restore ? 'Pulihkan' : 'Arkib'}</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
